import React from 'react';
import clsx from 'clsx';
import CheckIcon from '@mui/icons-material/Check';

import scss from './StoryCheckbox.module.scss';

function StoryCheckbox({ checked, onChange, readOnly = false, className, size = 'md' }) {
  const classNames = clsx(scss.checkbox, scss[size], checked && scss.checked, readOnly && scss.readOnly, className);

  const icon = <CheckIcon className={clsx(scss.icon, checked && scss.iconChecked)} />;

  if (readOnly) {
    return (
      <span className={classNames} aria-hidden>
        {icon}
      </span>
    );
  }

  const handleClick = (event) => {
    event.stopPropagation();
    onChange?.();
  };

  return (
    <button type='button' className={classNames} onClick={handleClick} aria-pressed={checked}>
      {icon}
    </button>
  );
}

export default StoryCheckbox;
